import { useTranslation } from 'react-i18next';

/**
 * orno's Light · Dark · System switch. The choice lives with orno (`orno.theme` in local storage, `data-theme` on
 * `<html>`, set before the first paint by orno-theme.js); every toggle on the page agrees with the others.
 */
export function ThemeToggle() {
  const { t } = useTranslation();
  return (
    <orno-theme-toggle
      label={t('theme.label')}
      light-label={t('theme.light')}
      dark-label={t('theme.dark')}
      system-label={t('theme.system')}
    />
  );
}
